import {useQuery} from '@tanstack/react-query'
import {httpGoogleAuth} from '@features/settings/http/settings.http.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
type UseGoogleAuthParams = {enabled: boolean; code: string; state: string}

export const useGoogleAuth = ({code, state, enabled}: UseGoogleAuthParams) =>
    useQuery({
        queryKey: [QUERY_KEYS.GOOGLE_AUTH, code, state],
        queryFn: () => httpGoogleAuth({params: {code, state}}),
        enabled
    })
